var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.2793 10.5871C4.2793 8.69332 5.81453 7.15808 7.70835 7.15808H35.1407C37.0345 7.15808 38.5698 8.69332 38.5698 10.5871V31.1614C38.5698 33.0552 37.0345 34.5905 35.1407 34.5905H7.70835C5.81454 34.5905 4.2793 33.0552 4.2793 31.1614V10.5871ZM10.312 10.5871L21.4245 20.3106L32.5371 10.5871H10.312ZM35.1407 12.8653L22.5536 23.8791C21.9071 24.4447 20.9419 24.4447 20.2955 23.8791L7.70835 12.8653V31.1614H35.1407V12.8653Z",
    fill: "#AAC7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.1afeb20dacc9d562e299262f53509217.svg";
export { ForwardRef as ReactComponent };